export default __webpack_public_path__ + "static/media/paypal.6c463cbc.png";